import React from 'react'
import {IoSearch} from 'react-icons/io5'
import styled from 'styled-components'

const InputContainer = styled.label`
  background: var(--colors-ui-base);
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  border-radius: var(--radii);
  box-shadow: var(--shadow);
  width: 100%;
  margin-bottom: 1.5rem;
  
  @media(min-width: 767px) {
    margin-bottom: 0;
    width: 280px;
  }
`

const Input = styled.input.attrs({
  type: 'search',
  placeholder: 'Search for a country'
})`
  margin-left: 2rem;
  border: none;
  outline: none;
  background: var(--colors-ui-base);
  color: var(--colors-text);
`

const Search = ({search, setSearch}) => {
  return (
    <InputContainer>
      <IoSearch />
      <Input onChange={(e) => setSearch(e.target.value)} value={search}/>
    </InputContainer>
  )
}

export default Search